export default __webpack_public_path__ + "static/media/loading-primary.7797a8f8.png";